import React from 'react'
import { times } from 'underscore'


export default class extends React.Component {
    render() {

		return (
			<div>
				{ times(3, function(i) {
					return <div className="col-sm-12 ptop15 mbot20" key={"loading-dashboard-" + i}>
						<div className="row">
							<div className="col-xs-12 mbot10">
								<div className="profile-image-wrapper mright10">
									<div className="profile-image breathe"></div>
								</div>
								<div className="pull-left breathe sub-title half"></div>
							</div>
							<div className="clearfix"></div>
						</div>
						<div className="breathe paragraph mbot10"></div>
						<div className="breathe sub-paragraph"></div>
						<div className="clearfix"></div>
		        	</div>
				} ) }
			</div> 
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/MainFeeds/ContentParts/ContentPart-Loading.jsx